export const COPY = {
  standard: {
    line1:
      'Your tradesperson has notified Ideal4Finance that they have finished your job.',
    line2:
      'You now need to sign off on the work or let us know if there is a problem.',
  },
  supplyOnly: {
    line1:
      'Your tradesperson has notified Ideal4Finance that they have delivered your goods.',
    line2:
      'You now need to sign off on the delivery or let us know if there is a problem.',
  },
  introduced: {
    line1:
      'Howdens have notified Ideal4Finance that they have made your initial delivery*',
    line2:
      'You now need to sign off on the delivery or let us know if there is a problem.',
    footer:
      '*Dependent on the timescale of bespoke products (such as Template & Fit solid work surfaces and Paint to Order kitchens), delivery may be in stages. Confirming delivery is indicative of receiving the initial delivery only.',
  },
};
